<template>
  <div class="font-style">
    <div
      class="item"
      v-for="(item, i) in items"
      :key="i"
      @click="select(item)"
      :class="{active: subtitle && item.name === subtitle.font.textAlign}"
    >
      <i
        class="icon"
        :class="[item.name]"
      ></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data () {
    return {
      items: [
        { text: '左对齐', name: 'left' },
        { text: '居中', name: 'center' },
        { text: '右对齐', name: 'right' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      subtitle: 'subtitle/selectSubtitle'
    })
  },
  methods: {
    select (item) {
      this.$store.commit('subtitle/updateSubtitleUndo', {
        subtitle: {
          font: {
            textAlign: item.name
          }
        }

      });
    }
  }
}
</script>

<style lang="scss" scoped>
.font-style {
  display: flex;
  align-items: center;
  width: 226px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
}
.item {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
  &.active {
    .left {
      background-image: url(../../../../static/svg/align-left-active.svg);
    }
    .center {
      background-image: url(../../../../static/svg/align-center-active.svg);
    }
    .right {
      background-image: url(../../../../static/svg/align-right-active.svg);
    }
  }
}
.item:nth-of-type(2) {
  position: relative;
  &:before,
  &:after {
    content: ' ';
    width: 1px;
    height: 16px;
    background: #ffffff;
    background-color: #d9ddea;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
}
.icon {
  display: inline-block;
  width: 16px;
  height: 16px;
}
.left {
  background-image: url(../../../../static/svg/align-left.svg);
}
.center {
  background-image: url(../../../../static/svg/align-center.svg);
}
.right {
  background-image: url(../../../../static/svg/align-right.svg);
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/textAlign.vue